@if (mobile()) {
  <app-navigation-toggle [items]="items()"></app-navigation-toggle>
} @else {
  <div class="nav nav-tabs justify-content-between w-100 cursor-pointer sticky-top" role="tablist">
    @for (item of items(); track $index) {
      <app-overview-navigation-tab-item class="nav-link flex-fill text-center p-0" [item]="item"></app-overview-navigation-tab-item>
    }
  </div>
}

